<template>
  <div>
    <img class="icon mr-2" :src="messageIcon(data.Location)" /> {{data.Subject}}
    <br />
    <small>{{getTimeString(data.StartTime)}} -  {{getTimeString(data.EndTime)}}
    <br />
    {{ $t('MESSAGES.TYPE.' + data.Location) }}</small>
  </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    messageIcon(message_type)
    {
      return "/img/message_type/" + message_type + ".png";
    },
    getTimeString(data){
      return this.getFormattedTime(data.toISOString());
    },
    getFormattedTime(data)
    {
      return this.FormatDateTime(data);
    }
  },
  computed: {
  },
  mounted: function() {
  },
};
</script>
<style>
  </style>
